module.exports = __webpack_public_path__ + "static/media/solar-panel.bac67214.svg";